module.exports = __webpack_public_path__ + "assets/img/default.ff1ea230.png";